module.exports = __webpack_public_path__ + "img/img_customer_homemaker.3846941d.svg";